import { useContext } from "react";
import { ThemeContext } from "./themeContext";

export default function ThemeButton() {
  const { theme, toggleTheme } = useContext(ThemeContext);

  return (
    <button
      onClick={toggleTheme}
      className="px-4 py-2 rounded-lg border  transition"
    >
      {theme === "dark" ? "dark" : "light"}
    </button>
  );
}
